/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
import axios from "axios";
import Select from 'react-select';
import config from '../../../config/config';
import TileComp from '../../ProcureToPayComp/TileComp/TileComp';
import styles from './TransitionHiringDashboardComp.module.css';
import './TransitionHiringDashboardComp.css';
import OverallTransitionSummaryCharts from '../OverallTransitionSummaryCharts/OverallTransitionSummaryCharts';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import HorizontalProgressChart from '../HorizontalProgressChart/HorizontalProgressChart';
import ReusableTable from '../../ReusableTable/ReusableTable';

import EntityStatusComparisonChart from '../EntityStatusComparisonChart/EntityStatusComparisonChart';
import TitleWithDetailedClick from '../TitleWithDetailedClick/TitleWithDetailedClick';
import StatusDashboard from '../OverallBarChart/StatusDashBorad';


const { API_BASE_URL } = config;

const TransitionHiringDashboardComp = () => {

    const { showPopup } = usePopupManager();
    const location = useLocation();
    const initialFilters = location.state || {
        inOutData: [],
        locationData: [],
        subDivisionData: [],
        yearData: [],
        quarterData: [],
    };

    const [filters, setFilters] = useState(initialFilters);
    const [showDashboard, setShowDashboard] = useState(false);
    const [showMainDashboard, setShowMainDashboard] = useState(false);
    const [detailedButtonClick, setDetailedButtonClick] = useState(false);
    const [InOutOptions, setInOutOptions] = useState([]);
    const [LocationOptions, setLocationOptions] = useState([]);
    const [SubDivisionOptions, setSubDivisionOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [quarterOptions, setQuarterOptions] = useState([]);
    const [entityOptions, setEntityOptions] = useState([]);
    const [towerOptions, settowerOptions] = useState([]);
    const [HiringstatusOptions, setHiringstatusOptions] = useState([]);
    const [towerselected, settowerselected] = useState([]);
    const [hiringStatusselected, sethiringStatusselected] = useState([]);
    const [actualStatusselected, setactualStatusselected] = useState([]);
    const [actualstatusOptions, setactualstatusOptions] = useState([]);
    const [InOut, setInOut] = useState([]);
    const [Location, setLocation] = useState([]);
    const [SubDivision, setSubDivision] = useState([]);
    const [Year, setYear] = useState([]);
    const [Quarter, setQuarter] = useState([]);
    const [overall, setOverall] = useState([]);
    const [entity, setEntity] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedEntityName, setSelectedEntityName] = useState([]);
    const [selectedTowerName, setselectedTowerName] = useState([]);
    const [OverallHiringStatus, setOverallHiringStatus] = useState({})
    const [OveralBudgetedvsActual, setOveralBudgetedvsActual] = useState({})
    const [HiringStatusDetailsTable, setHiringStatusDetailsTable] = useState([])
    const [EntitywiseDrilldown, setEntitywiseDrilldown] = useState([])
    const [TowerWiseOverall, setTowerWiseOverall] = useState([])
    const [CSVData, setCSVData] = useState([])
    const [hasApplied, setHasApplied] = useState(false);
    const [selectedPage, setSelectedPage] = useState();
    const [startPage, setStartPage] = useState(0);
    const [endPage, setEndPage] = useState(100);
    const itemsPerPage = 100;


    const [transitionleadOptions, settransitionleadOptions] = useState([]);
    const [transitionlead, settransitionlead] = useState([]);


    useEffect(() => {
        if (hasApplied) {
            handleApply();
        }
    }, [selectedPage, hasApplied]);


    const handleInOutChange = (selected) => {
        // setInOut(selected);
        setInOut(selected || []);
        setFilters(prev => ({ ...prev, inOutData: selected }));
    };

    const handleLocationChange = (selected) => {
        // setLocation(selected);
        setLocation(selected || []);
        setFilters(prev => ({ ...prev, locationData: selected }));
    };

    const handleSubDivisionChange = (selected) => {
        // setSubDivision(selected);
        setSubDivision(selected || []);
        setFilters(prev => ({ ...prev, subDivisionData: selected }));
    };


    const handleTowerChange = (selected) => {
        const selectedArray = selected || [];
        settowerselected(selected || []);
        setFilters(prev => ({ ...prev, towerData: selected }));
        const selectedtowerNames = selectedArray.map(e => e.label);
        setselectedTowerName(selectedtowerNames.join(', '));

    };


    const handleYearChange = (selected) => {
        if (!selected) {
            setYear([]);
            setQuarter([]);
            setFilters(prev => ({ ...prev, yearData: [], quarterData: [] }));
            return;
        }
        const updatedYear = [selected];
        setYear(updatedYear);
        setFilters(prev => ({ ...prev, yearData: updatedYear }));
        setQuarter([]);
        setFilters(prev => ({ ...prev, quarterData: [] }));
    };


    const handleQuarterChange = (selected) => {
        // setQuarter(selected);
        setQuarter(selected || []);
        setFilters(prev => ({ ...prev, quarterData: selected }));
    };


    const handleHiringStatusChange = (selected) => {
        // setLocation(selected);
        sethiringStatusselected(selected || []);
        setFilters(prev => ({ ...prev, locationData: selected }));
    };

    const handleActualStatusChange = (selected) => {
        // setLocation(selected);
        setactualStatusselected(selected || []);
        setFilters(prev => ({ ...prev, locationData: selected }));
    };


    const handletransitionlead = (selected) => {
        // setQuarter(selected);
        const selectedArray = selected || [];
        settransitionlead(selectedArray || []);
        setFilters(prev => ({ ...prev, quarterData: selected }));
    };

    const fetchInOutOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-in-out`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setInOutOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchLocationOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-location`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setLocationOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchSubDivisionOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-sub-division`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setSubDivisionOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchYearOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-year`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    let YearData = response.data
                    // YearData.push(
                    //     { label: 'NA', value: 'null' })
                    setYearOptions(YearData);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchQuerterOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-quarter`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setQuarterOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchEntityOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-entity`, {
                headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
            });
            const data = response.data || [];
            setEntityOptions(data);
            // if (data.length > 0) {
            //   setEntity([data[0]]);
            //   setSelectedEntityName(data[0].label);
            // }
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchTowerOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-tower`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    settowerOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchHiringstatusOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-Hiring-status`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setHiringstatusOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };


    const fetchActualstatusOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-Actual-status`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setactualstatusOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };


    const fetchtransitionleadOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-lead`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    let YearData = response.data
                    // console.log("YearData", YearData)
                    // YearData.push(
                    //   { label: 'NA', value: 'null' })
                    settransitionleadOptions(YearData);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };







    useEffect(() => {
        fetchInOutOptions();
        fetchLocationOptions();
        fetchSubDivisionOptions();
        fetchYearOptions();
        fetchQuerterOptions();
        fetchEntityOptions();
        fetchTowerOptions()
        fetchHiringstatusOptions()
        fetchActualstatusOptions()
        fetchtransitionleadOptions()
        // console.log("main page filter check -------------->", filters);
    }, []);


    const handleApply = () => {
        // debugger
        const selectedEntity = entity.map(e => e.value);
        const inoutFilterData = InOut.map(e => e.value);
        const locationFilterData = Location.map(e => e.value);
        const subDivisionFilterData = SubDivision.map(e => e.value);
        const yearFilterData = Year.map(e => e.value);
        const quarterData = Quarter.map(e => e.value);
        const subDivison = SubDivision.map(e => e.value);
        const TOWERS = towerselected.map(e => e.value);
        const hiringStatus = hiringStatusselected.map(e => e.value);
        const actualStatus = actualStatusselected.map(e => e.value);
        const transitionleadSelect = transitionlead.map(e => e.value);


        // if (yearFilterData.length === 0) {
        //     showPopup({
        //         type: MESSAGE_TYPE.INFORMATION,
        //         contextText: MESSAGE_TYPE.INFORMATION,
        //         info: "Please select Financial Year",
        //     });
        //     return;
        // }

        setIsLoading(true);

        const fetchHiringStatus = async () => {
            try {
                const response = await axios.post(
                    `${API_BASE_URL}/api/Overall-Hiring-Summary-Dashboard`,
                    {
                        selectedInout: inoutFilterData,
                        selectedLocation: locationFilterData,
                        selectedSubDiv: subDivisionFilterData,
                        selectedEntity: selectedEntity,
                        selectedYear: yearFilterData,
                        selectedQuarter: quarterData,
                        selectedSubDiv: subDivison,
                        selectedTower: TOWERS,
                        selectedHiringstatus: hiringStatus,
                        selectedActualstatus: actualStatus,
                        selecttransitionlead: transitionleadSelect,
                        start: startPage,
                        end: endPage,
                    },
                    {
                        headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' }
                    }
                );

                console.log("response", response)

                const data = response.data;

                setOverallHiringStatus(data.getOverallHiringStatusData?.equipmentData)
                setOveralBudgetedvsActual(data.getBudgetedvsActualnDataHiring)
                setHiringStatusDetailsTable(data?.getHiringStatusDetailsTableData)
                setEntitywiseDrilldown(data?.getHiringStatusEntitywiseDrilldownPullHive)
                setTowerWiseOverall(data?.getTowerWiseFTEDataPullHive)
                setCSVData(data?.getHiringStatusDetailsTableData?.tableCSV)

            } catch (error) {
                console.error('Error fetching total tiles data:', error);
            }
        };

        Promise.all([
            fetchHiringStatus(),
        ]).then(() => {
            // setShowDashboard(true);
            // setShowMainDashboard(true);
            // setDetailedButtonClick(false);
            // setIsLoading(false);

            if (detailedButtonClick === false) {
                setShowDashboard(true);
                setShowMainDashboard(true);
                setDetailedButtonClick(false);
                setIsLoading(false);
            } else {
                setDetailedButtonClick(true);
                setShowMainDashboard(false);
                setShowDashboard(true);
                setIsLoading(false);
            }


        });

    };

    const handleReset = () => {
        setInOut([]);
        setLocation([]);
        setSubDivision([]);
        setYear([]);
        setQuarter([]);
        // setEntityOptions([])
        settowerselected([])
        sethiringStatusselected([])
        setactualStatusselected([])
        setSelectedEntityName([]);
        setselectedTowerName([]);
        setEntity([])
        setFilters({
            inOutData: [],
            locationData: [],
            subDivisionData: [],
            yearData: [],
            quarterData: [],
        });
        setShowDashboard(false);
        setShowMainDashboard(false);
        setDetailedButtonClick(false);
    };


    const handleCSVDownload = () => {
        const csvHeader = columns.map(col => col.header).join(',');

        const csvRows = CSVData.map(row =>
            columns
                .map(col => {
                    const value = row[col.accessor];

                    // Convert to string safely (handles null, undefined, numbers)
                    const stringValue =
                        value === null || value === undefined
                            ? ''
                            : String(value);

                    // Escape double quotes
                    return `"${stringValue.replace(/"/g, '""')}"`;
                })
                .join(',')
        );

        const csvContent = [csvHeader, ...csvRows].join('\n');

        const blob = new Blob([csvContent], {
            type: 'text/csv;charset=utf-8;',
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Transition_Overall_status.csv';
        link.click();
    };



    const handleEntity = (selected) => {
        const selectedArray = selected || [];
        setEntity(selectedArray);
        const selectedEntityNames = selectedArray.map(e => e.label);
        setSelectedEntityName(selectedEntityNames.join(', '));

        // const selectedEntityValues = selectedArray.map(e => e.value);
        // const inoutFilterData = InOut.map(e => e.value);
        // const locationFilterData = Location.map(e => e.value);
        // const subDivisionFilterData = SubDivision.map(e => e.value);
        // const yearFilterData = Year.map(e => e.value);
        // const quarterData = Quarter.map(e => e.value);

        // fetchTransitionOverallWithEntity(
        //     selectedEntityValues,
        //     inoutFilterData,
        //     locationFilterData,
        //     subDivisionFilterData,
        //     yearFilterData,
        //     quarterData
        // );
    };

    useEffect(() => {
        setOverall({ value: 'overall', label: 'Overall summary' });
    }, []);

    // Quarterwise Chart data

    const customStylesMultiSelect = {
        control: (provided) => ({
            ...provided,
            minHeight: '40px',
            flexWrap: 'wrap',
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '100px',
            overflowY: 'auto',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            overflow: 'visible',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
        }),
        option: (provided) => ({
            ...provided,
            padding: '8px 12px',
        }),
    };


    const columns = [
        { header: "Legal_Entity", accessor: "Legal_Entity" },
        { header: "Tower", accessor: "Tower" },
        { header: "Work Area", accessor: "Work_Area" },
        { header: "Employee_Grade", accessor: "Employee_Grade" },
        { header: "Location", accessor: "Location" },
        { header: "PO_Approval", accessor: "TML__EXCOM_APPROVAL_JLR_UK__Subsidiaries__PO_Approval" },
        { header: "EXCOM_Approval_Date", accessor: "EXCOM_Approval_Date" },
        { header: "JD_Shared_Date", accessor: "JD_Shared_Date" },
        { header: "Hiring_Status", accessor: "Hiring_Status" },
        { header: "Actual_FTE_Nos", accessor: "Actual_FTE_Nos" },
        { header: "Billing_GO_live_Month", accessor: "Billing_GO_live_Month" },
        { header: "Resource_Target_Date", accessor: "Resource_Target_Date" },
        { header: "Actual_Status", accessor: "Actual_Status" },
        { header: "Resource_Deployment_Date", accessor: "Resource_Deployment_Date" },
    ];




    const handlePageChange = (page) => {
        setHasApplied(true)
        setSelectedPage(page);
        let endPageVal = page * 100
        let startPageVal = endPageVal - 99

        setStartPage(startPageVal)
        setEndPage(endPageVal)
        // console.log(`Selected page: ${page}`);

    };


    const [totalRecords, setTotalRecords] = useState(0);
    const [dataLoading, setdataLoading] = useState(false);




    const labelsFTEWiseChart = [
        "Internal fulfillment",
        "Joined",
        "DOJ Received",
        "DOJ Not Received",
        "New pipeline",
        "Overdue",
        "OTON",
        "Total"
    ]


    const handleDetailClick = () => {
        setDetailedButtonClick(true);
        setShowMainDashboard(false);
    }

    const handleMainPageClick = () => {
        setDetailedButtonClick(false);
        setShowMainDashboard(true);
    }

    return (
        <>
            {/* <h6 style={{ color: "red", paddingLeft: "500px" }}>Note: Sample Data</h6> */}
            <div className={styles.filter_panel_container}>
                <div className={styles.filter_panel_row}>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>IN/OUT</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={InOut}
                                onChange={handleInOutChange}
                                options={InOutOptions}
                                closeMenuOnSelect={false}
                                isMulti
                                isSearchable={true}
                                placeholder="Select IN/OUT"
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Location</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={Location}
                                onChange={handleLocationChange}
                                options={LocationOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Location"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Legal Entity</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={entity}
                                placeholder={<div className="select-placeholder-text">Select Legal Entity</div>}
                                onChange={handleEntity}
                                options={entityOptions}
                                // isSearchable={false}
                                isMulti
                                isSearchable={true}
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Sub-Division</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={SubDivision}
                                onChange={handleSubDivisionChange}
                                options={SubDivisionOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Sub-Division"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Tower</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={towerselected}
                                onChange={handleTowerChange}
                                options={towerOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Tower"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>

                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Financial Year</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={Year}
                                onChange={handleYearChange}
                                options={yearOptions}
                                // isMulti
                                isSearchable={true}
                                placeholder="Financial Year"
                                // closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.filter_panel_row} style={{ paddingTop: "10px" }}>

                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Quarter</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={Quarter}
                                onChange={(selected) => {
                                    if (Year.length === 0) {
                                        showPopup({
                                            type: MESSAGE_TYPE.INFORMATION,
                                            contextText: MESSAGE_TYPE.INFORMATION,
                                            info: "Please select Financial Year first before selecting Quarter.",
                                        });
                                        return;
                                    }
                                    handleQuarterChange(selected);
                                }}
                                options={quarterOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Quarter"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                                isDisabled={Year.length === 0}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Hiring status</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={hiringStatusselected}
                                onChange={handleHiringStatusChange}
                                options={HiringstatusOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select status"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>

                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Actual status</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={actualStatusselected}
                                onChange={handleActualStatusChange}
                                options={actualstatusOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="actual status"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>

                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Transition Lead</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={transitionlead}
                                onChange={handletransitionlead}
                                options={transitionleadOptions}
                                isSearchable={true}
                                isMulti
                                placeholder="Transition Lead"
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <div className={styles.filter_select_wrapper}>
                            <div className="filter-panel-col">
                                <button onClick={handleApply} className="btn apply-btn">
                                    Apply
                                </button>
                                <button onClick={handleReset} className="btn reset-btn">
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 9999,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status"></div>
                        <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>

                    </div>
                </div>
            )}
            {showDashboard && (
                <>
                    <div>
                        {showMainDashboard && (
                            <div style={{ overflowX: 'hidden' }}>
                                <div className="row">
                                    <TitleWithDetailedClick
                                        // title="Overall Hiring Summary"
                                        title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} Transition Summary` : " Overall  Transition Summary"}

                                        handleDetailClick={handleDetailClick}
                                    />

                                    <div className="col-12 col-lg-12 mb-3">
                                        <DashboardSection infoIcondata="MANUAL CSV Data" title="Overall Hiring Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters}>
                                            <StatusDashboard equipmentData={OverallHiringStatus} />
                                        </DashboardSection>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-6 col-lg-5">
                                        <DashboardSection infoIcondata="MANUAL CSV Data" title="Budgeted vs Actual FTE by Hiring Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters}>
                                            <div>
                                                {/* <HorizontalProgressChart data={chartDataProgress} /> */}
                                                <HorizontalProgressChart
                                                    labels={labelsFTEWiseChart}
                                                    actualFTEs={OveralBudgetedvsActual?.actualFTEs}
                                                    budgetedFTEs={OveralBudgetedvsActual?.budgetedFTEs}
                                                    heightValues={255}
                                                />
                                            </div>
                                        </DashboardSection>
                                    </div>
                                    <div className="col-6 col-lg-7">
                                        <DashboardSection infoIcondata="MANUAL CSV Data" title="Hiring Status Details" disableDetailView={true} detailPath="">

                                            <ReusableTable
                                                showPagination={true}
                                                data={HiringStatusDetailsTable?.tableData} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={HiringStatusDetailsTable?.totalCount} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading} currentPage={selectedPage ? selectedPage - 1 : 0}
                                            />

                                        </DashboardSection>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* after click on detailed page */}
                        {detailedButtonClick && (
                            <div>
                                <TitleWithDetailedClick
                                    title="Detailed View"
                                    handleBackClick={handleMainPageClick}
                                    showBackButton={true}
                                    showDetailedButton={false}
                                />
                                <div className="row">
                                    <div className="col-12 col-lg-12 mb-3">
                                        <DashboardSection infoIcondata="MANUAL CSV Data" title="Entity wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters}>
                                            <EntityStatusComparisonChart
                                                title={selectedEntityName}
                                                labels={EntitywiseDrilldown?.labelsFTEWiseChart}
                                                actualFTEs={EntitywiseDrilldown?.entityActualFTEs}
                                                budgetedFTEs={EntitywiseDrilldown?.entityBudgetedFTEs}
                                            />
                                        </DashboardSection>
                                    </div>
                                    {/* <div className="col-12 col-lg-6 mb-3">
                                        <DashboardSection infoIcondata="MANUAL CSV Data" title="Tower Wise Overall Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters}>
                                            <div>
                                                <HorizontalProgressChart
                                                    labels={TowerWiseOverall?.towerWiseOverallLabels}
                                                    actualFTEs={TowerWiseOverall?.towerWiseOverallActual}
                                                    budgetedFTEs={TowerWiseOverall?.towerWiseOverallBudgeted}
                                                />
                                            </div>
                                        </DashboardSection>
                                    </div> */}
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12 mb-3">
                                        <DashboardSection infoIcondata="MANUAL CSV Data" title="Transition Details" disableDetailView={true} detailPath="">

                                            <ReusableTable
                                                showPagination={true}
                                                data={HiringStatusDetailsTable?.tableData} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={HiringStatusDetailsTable?.totalCount} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading} currentPage={selectedPage ? selectedPage - 1 : 0}
                                            />
                                        </DashboardSection>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default TransitionHiringDashboardComp;
